import Button from "@lhd/components/Button";
import ModalConfirm from "@lhd/components/Modal/ModalConfirm";
import Table from "@lhd/components/Table";
import { FC } from "react";
import useMainContent, { Props, ReceivedProps } from "./hook";
import { Styles } from "./styled";
import ModalForm from "../modalForm/index";
import ButtonCommon from "@lhd/components/ButtonCommon";

const MainContentLayout: FC<Props> = ({
  columnDefs,
  rowData,
  gridApi,
  gridRef,
  onGridReady,
  onFilterUpdate,
  isLoading,
  isFetching,
  pageSize,
  total,
  page,
  isDeleting,
  onShowModalDelete,
  onCancelModalDelete,
  listSelected,
  isDelete,
  handleDeleteMultipleCell,
  handleCancelModal,
  handleOpenModal,
  isOpenModal,
  modalMode,
  selectedId,
  onSuccess,
  rowHeight,
  displaySize,
  size,
  height,
  filterInfo,
  setFilterInfo,
  options,
}) => {
  return (
    <Styles text_scale={displaySize}>
      <div>
        <Table
          gridRef={gridRef}
          rowData={rowData}
          loading={isLoading || isFetching || isDeleting}
          onCreate={handleOpenModal}
          onFilterUpdate={onFilterUpdate}
          isShowBtnCreate={true}
          preHeaderChildren={
            <ButtonCommon
              name="一括削除"
              className={
                listSelected && listSelected?.length > 0
                  ? "btn-delete"
                  : "btn-delete-disable"
              }
              disabled={!(listSelected && listSelected?.length)}
              onClick={onShowModalDelete}
              style={{
                fontSize: size,
                height: `${height}px`,
                width: "fit-content",
              }}
            />
          }
          tableHeight={isOpenModal ? "calc(50vh - 150px)" : undefined}
          autoFitRemainingHeight={!isOpenModal}
          rowHeight={height + 8}
          headerHeight={height + 8}
          columnDefs={[...columnDefs]}
          gridApi={gridApi}
          onGridReady={onGridReady}
          pageSize={pageSize}
          total={total}
          page={page}
          isShowButtonEnd
          isShowPaginationHeader={true}
          defaultColDef={{ floatingFilter: false }}
          floatingFiltersHeight={0}
          context={{ filterInfo, handleSetFilterInfo: setFilterInfo, options }}
        />
      </div>

      <ModalConfirm
        isSubmitting={isDeleting}
        isOpen={isDelete}
        onCancel={onCancelModalDelete}
        onOk={handleDeleteMultipleCell}
        content={"本当に削除しますか。"}
      />
      <ModalForm
        isOpen={isOpenModal}
        handleCancel={handleCancelModal}
        selectedId={selectedId}
        onSuccess={onSuccess}
        pageMode={modalMode}
        isQuickViewMode
      />
    </Styles>
  );
};

const MainContent: FC<ReceivedProps> = (props) => (
  <MainContentLayout {...useMainContent(props)} />
);

export default MainContent;
